import {
  format,
  formatISO,
  getYear,
  getMonth,
  getDate,
  add,
  startOfDay,
  differenceInDays,
  parseISO,
  parse,
  isBefore,
} from 'date-fns';
import { es } from 'date-fns/locale';

function toDate(date: Date | string | number): Date {
  if (typeof date === 'string') return parseISO(date);
  return new Date(date);
}

export function formatDate(
  date: Date | string | number,
  pattern: string
): string {
  return format(toDate(date), pattern, { locale: es });
}

export function formatISODate(date: Date | string | number): string {
  return formatISO(toDate(date));
}

export function parseDate(value: string, pattern: string): Date {
  return parse(value, pattern, new Date());
}

export function getYearOf(date: Date | string): number {
  return getYear(toDate(date));
}

export function getMonthOf(date: Date | string): number {
  return getMonth(toDate(date));
}

export function getDateOf(date: Date | string): number {
  return getDate(toDate(date));
}

export function addToDate(
  date: Date | string,
  amount: number,
  unit: 'years' | 'months' | 'days'
): Date {
  return add(toDate(date), { [unit]: amount });
}

export function daysDiff(dateA: Date | string, dateB: Date | string): number {
  return differenceInDays(startOfDay(toDate(dateA)), startOfDay(toDate(dateB)));
}

export function isDateBefore(
  date: Date | string,
  other: Date | string
): boolean {
  return isBefore(toDate(date), toDate(other));
}
